import React from 'react';
import cx from 'classnames';
import styles from './ShareLinks.module.scss';
import { LinkBase } from '../index';
import { SHARE_LINKS } from '../../lib/constants';

const ShareLinks = () => {
    const currentPageLink = window.location.href;

    const SocialItem = ({ socialMedia }) => (
        <li className={cx(styles['share-media-item'])}>
            <LinkBase
                addIdSuffix={true}
                altText={socialMedia.altTextLink}
                className={cx(styles['share-media-link'])}
                target="external"
                url={`${socialMedia.link}${currentPageLink}`}
            >
                <img
                    alt={socialMedia.altTextIcon}
                    className={cx(styles['share-media-item-icon'])}
                    src={socialMedia.icon}
                    loading="lazy"
                />
            </LinkBase>
        </li>
    );

    return (
        <ul className={cx(styles['share-media-list'])}>
            <SocialItem socialMedia={SHARE_LINKS.FACEBOOK} />
            <SocialItem socialMedia={SHARE_LINKS.EMAIL} />
            <SocialItem socialMedia={SHARE_LINKS.LINKEDIN} />
            <SocialItem socialMedia={SHARE_LINKS.X} />
        </ul>
    );
};

ShareLinks.displayName = 'ShareLinks';

export default ShareLinks;
